import classnames from 'classnames';
import styles from './LifecycleIndicator.scss';

export const LifecycleIndicator = (props) => (
    <div
        className={
            classnames(
                styles.lifecycleIndicator,
                props.className, {
                    [styles.lifecycleIndicatorBackground]: props.withBackground,
                }
            )
        }
        data-cy="LifecycleIndicator"
    >
        <h3 data-cy="LifecycleIndicator-title">
            {props.title}
        </h3>
    </div>
);

export default LifecycleIndicator;
